import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footers";
import Hero from "../components/Home/Hero";
import Features from "../components/Home/Features";
import Portfolio from "../components/Home/Portfolio";
import CoreValues from "../components/Home/CoreValues";
import Testimonials from "../components/Home/Testimonials";
import FAQ from "../components/Home/FAQ";
import CTA from "../components/Home/CTA";
import Contact from "../components/Home/Contact";

function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Features />
        <Portfolio />
        <CoreValues />
        <Testimonials />
        <FAQ />
        <CTA />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

export default Home;
